export default __webpack_public_path__ + "static/media/promo-active.52ca2432.svg";